import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { groupItemsByTypes, mapGamesWithJackpotsV2 } from '@/logic/main/utils';
import { SEARCH_RESULT_CATEGORY_ID } from '@/model/constants';
import { getLocale } from '@/utils';

export const getSearchItemsContent = async (context: LogicContext) => {
  const { searchItems, currentType } = context.search;
  const gamesWithJackpotV2 = mapGamesWithJackpotsV2(
    searchItems,
    context.currentJackpotsV2
  );
  const groupedItems = groupItemsByTypes(gamesWithJackpotV2);
  const locale = getLocale(config);
  const currency = context.user?.currency || config.default_currency;
  const { loggedIn } = context.user;
  const searchResultCategory = {
    id: SEARCH_RESULT_CATEGORY_ID,
    title: `Search Results`,
    games: groupedItems[currentType],
  };

  return {
    updates: [
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchResult.properties`,
          value: {
            category: searchResultCategory,
            locale,
            currency,
            loggedIn,
          },
        },
      },
    ],
  };
};
